import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
import AdvancedThemeConfig from "segments/core-configs/advanced-theme-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    ...AdvancedThemeConfig,
    fullParagraphAdvancedConfig: {
      type: FIELD_TYPES.NESTED,
      label: "Paragraph Advanced Config",
      fields: FullParagraphAdvancedFieldsConfig
    },
    desktopHorizontalPadding: {
      type: FIELD_TYPES.TEXT,
      label: "Desktop Horizontal Padding"
    },
    borderOpacity: {
      type: FIELD_TYPES.TEXT,
      label: "Border opacity"
    },
    disableCardsHoverStyle: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Disable cards hover style"
    },
    slideBreakingPoints: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Slide Breaking Points",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          breakpoint: {
            type: FIELD_TYPES.TEXT,
            label: "Breakpoint"
          },
          slidesToShow: {
            type: FIELD_TYPES.TEXT,
            label: "Cards to show"
          }
        }
      }
    }
  }
};
